import { render, staticRenderFns } from "./addShopVipUser.vue?vue&type=template&id=71df522f"
import script from "./addShopVipUser.vue?vue&type=script&lang=js"
export * from "./addShopVipUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports